import { useState } from "react";
import DatePicker, { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { PageBanner } from "@/shared/components/PageBanner";
import { useApproveShiftSwap, useRejectShiftSwap, useRequestShiftSwap, useShiftSwapRequests } from "../api";
import { useV1UsersList } from "@/api/generated/v1/v1";
import type { ShiftSwapRequest } from "../types";

export default function ShiftSwapPage() {
  const { data: swaps = [] } = useShiftSwapRequests();
  const requestSwap = useRequestShiftSwap();
  const approve = useApproveShiftSwap();
  const reject = useRejectShiftSwap();

  const { data: usersData } = useV1UsersList({ page_size: 1000 } as any);
  const users = usersData?.results || [];

  const [form, setForm] = useState({
    operator_a_user_id: "",
    date_a: "",
    operator_b_user_id: "",
    date_b: "",
    reason: "",
  });

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "1.5rem", fontFamily: "var(--font-family-fa, sans-serif)" }} dir="rtl">
      <PageBanner
        title="جابجایی شیفت بین نفرات"
        subtitle="درخواست و مدیریت جابجایی شیفت بین دو اپراتور در روزهای مختلف"
        icon="🔁"
        helpLink="/help/shopfloor/shift-swaps"
      />

      <section className="brand-card-extand" style={{ padding: "1.5rem", border: "1px solid var(--color-border, #E4DCC8)" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", paddingBottom: "0.75rem", marginBottom: "1.25rem", borderBottom: "1px solid var(--color-border, #E4DCC8)" }}>
          <h2 style={{ margin: 0, fontSize: "1.1rem", fontWeight: 800, color: "#007270" }}>درخواست جابجایی</h2>
        </div>
        <div style={{ display: "flex", flexWrap: "wrap", gap: "1.25rem", alignItems: "flex-end" }}>
          <div style={{ flex: "1 1 200px" }}>
            <label style={{ fontSize: "0.85rem", fontWeight: 700, color: "#2B2B2B", display: "block", marginBottom: "4px" }}>اپراتور A</label>
            <select
              style={{ width: "100%", padding: "8px 12px", borderRadius: "10px", border: "1px solid var(--color-border, #E4DCC8)", background: "#FFFFFF", color: "#2B2B2B", fontSize: "0.85rem", outline: "none", cursor: "pointer" }}
              value={form.operator_a_user_id}
              onChange={(e) => setForm((s) => ({ ...s, operator_a_user_id: e.target.value }))}
            >
              <option value="">— انتخاب اپراتور A —</option>
              {users.map((u: any) => (
                <option key={u.id} value={u.id}>
                  {u.first_name} {u.last_name} ({u.username})
                </option>
              ))}
            </select>
          </div>
          <div style={{ flex: "1 1 200px", position: "relative" }}>
            <label style={{ fontSize: "0.85rem", fontWeight: 700, color: "#2B2B2B", display: "block", marginBottom: "4px" }}>تاریخ A</label>
            <DatePicker
              calendar={persian}
              locale={persian_fa}
              calendarPosition="bottom-right"
              portal
              value={form.date_a || ""}
              onChange={(date: DateObject | null) => {
                setForm((prev) => ({
                  ...prev,
                  date_a: date ? date.format("YYYY-MM-DD") : "",
                }));
              }}
              style={{ width: "100%", padding: "8px 12px", borderRadius: "10px", border: "1px solid var(--color-border, #E4DCC8)", background: "#FFFFFF", color: "#2B2B2B", fontSize: "0.85rem", outline: "none", height: "auto" }}
              containerStyle={{ width: "100%" }}
              placeholder="انتخاب تاریخ شمسی..."
            />
          </div>
          <div style={{ flex: "1 1 200px" }}>
            <label style={{ fontSize: "0.85rem", fontWeight: 700, color: "#2B2B2B", display: "block", marginBottom: "4px" }}>اپراتور B</label>
            <select
              style={{ width: "100%", padding: "8px 12px", borderRadius: "10px", border: "1px solid var(--color-border, #E4DCC8)", background: "#FFFFFF", color: "#2B2B2B", fontSize: "0.85rem", outline: "none", cursor: "pointer" }}
              value={form.operator_b_user_id}
              onChange={(e) => setForm((s) => ({ ...s, operator_b_user_id: e.target.value }))}
            >
              <option value="">— انتخاب اپراتور B —</option>
              {users.map((u: any) => (
                <option key={u.id} value={u.id}>
                  {u.first_name} {u.last_name} ({u.username})
                </option>
              ))}
            </select>
          </div>
          <div style={{ flex: "1 1 200px", position: "relative" }}>
            <label style={{ fontSize: "0.85rem", fontWeight: 700, color: "#2B2B2B", display: "block", marginBottom: "4px" }}>تاریخ B</label>
            <DatePicker
              calendar={persian}
              locale={persian_fa}
              calendarPosition="bottom-right"
              portal
              value={form.date_b || ""}
              onChange={(date: DateObject | null) => {
                setForm((prev) => ({
                  ...prev,
                  date_b: date ? date.format("YYYY-MM-DD") : "",
                }));
              }}
              style={{ width: "100%", padding: "8px 12px", borderRadius: "10px", border: "1px solid var(--color-border, #E4DCC8)", background: "#FFFFFF", color: "#2B2B2B", fontSize: "0.85rem", outline: "none", height: "auto" }}
              containerStyle={{ width: "100%" }}
              placeholder="انتخاب تاریخ شمسی..."
            />
          </div>
          <div style={{ flex: "1 1 100%" }}>
            <label style={{ fontSize: "0.85rem", fontWeight: 700, color: "#2B2B2B", display: "block", marginBottom: "4px" }}>دلیل</label>
            <input
              style={{ width: "100%", padding: "8px 12px", borderRadius: "10px", border: "1px solid var(--color-border, #E4DCC8)", background: "#FFFFFF", color: "#2B2B2B", fontSize: "0.85rem", outline: "none" }}
              placeholder="توضیحات و دلیل جابجایی"
              value={form.reason}
              onChange={(e) => setForm((s) => ({ ...s, reason: e.target.value }))}
            />
          </div>
          <div style={{ flex: "1 1 100%", display: "flex", justifyContent: "flex-end" }}>
            <button style={{ padding: "8px 16px", borderRadius: "10px", background: "#007270", color: "#FFF", border: "none", fontSize: "0.85rem", fontWeight: 700, cursor: requestSwap.isPending ? "not-allowed" : "pointer", opacity: requestSwap.isPending ? 0.7 : 1 }} onClick={() => requestSwap.mutate(form)} disabled={requestSwap.isPending}>
              ثبت درخواست جابجایی
            </button>
          </div>
        </div>
      </section>

      <section className="brand-card-extand" style={{ padding: "1.5rem", border: "1px solid var(--color-border, #E4DCC8)" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", paddingBottom: "0.75rem", marginBottom: "1.25rem", borderBottom: "1px solid var(--color-border, #E4DCC8)" }}>
          <h2 style={{ margin: 0, fontSize: "1.1rem", fontWeight: 800, color: "#007270" }}>درخواست‌های جابجایی</h2>
        </div>
        <div style={{ overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "0.85rem", textAlign: "right" }}>
            <thead>
              <tr style={{ background: "rgba(0,0,0,0.04)", borderBottom: "1px solid var(--color-border, #E4DCC8)" }}>
                <th style={{ padding: "12px 10px", fontWeight: 700, color: "#2B2B2B" }}>A / تاریخ</th>
                <th style={{ padding: "12px 10px", fontWeight: 700, color: "#2B2B2B" }}>B / تاریخ</th>
                <th style={{ padding: "12px 10px", fontWeight: 700, color: "#2B2B2B" }}>وضعیت</th>
                <th style={{ padding: "12px 10px", fontWeight: 700, color: "#2B2B2B" }}>عملیات</th>
              </tr>
            </thead>
            <tbody>
              {swaps.map((s: ShiftSwapRequest) => {
                const opA = users.find((u: any) => u.id === s.operator_a_user_id);
                const operatorA = opA ? `${opA.first_name} ${opA.last_name}` : s.operator_a_user_id;
                
                const opB = users.find((u: any) => u.id === s.operator_b_user_id);
                const operatorB = opB ? `${opB.first_name} ${opB.last_name}` : s.operator_b_user_id;

                return (
                  <tr key={s.id} style={{ borderBottom: "1px solid var(--color-border, #E4DCC8)" }}>
                    <td style={{ padding: "12px 10px", color: "#444" }}>
                      <span style={{ fontWeight: 600 }}>{operatorA}</span> <span style={{ color: "#888", margin: "0 4px" }}>/</span> {s.date_a}
                    </td>
                    <td style={{ padding: "12px 10px", color: "#444" }}>
                      <span style={{ fontWeight: 600 }}>{operatorB}</span> <span style={{ color: "#888", margin: "0 4px" }}>/</span> {s.date_b}
                    </td>
                    <td style={{ padding: "12px 10px" }}>
                      <span style={{ padding: "4px 8px", borderRadius: "6px", fontSize: "0.75rem", fontWeight: 700, background: s.status === 'pending' ? "rgba(245, 158, 11, 0.15)" : s.status === 'approved' ? "rgba(16, 185, 129, 0.15)" : "rgba(239, 68, 68, 0.15)", color: s.status === 'pending' ? "#D97706" : s.status === 'approved' ? "#10B981" : "#EF4444" }}>
                        {s.status === 'pending' ? 'در انتظار تأیید' : s.status === 'approved' ? 'تأیید شده' : 'رد شده'}
                      </span>
                    </td>
                    <td style={{ padding: "12px 10px" }}>
                      {s.status === "pending" && (
                        <div style={{ display: "flex", gap: "6px" }}>
                          <button style={{ padding: "6px 12px", borderRadius: "8px", background: "rgba(16, 185, 129, 0.1)", border: "1px solid rgba(16, 185, 129, 0.2)", color: "#10B981", fontSize: "0.8rem", fontWeight: 700, cursor: "pointer", transition: "all 0.2s" }} onClick={() => approve.mutate(s.id)}>
                            تأیید
                          </button>
                          <button style={{ padding: "6px 12px", borderRadius: "8px", background: "rgba(239, 68, 68, 0.1)", border: "1px solid rgba(239, 68, 68, 0.2)", color: "#EF4444", fontSize: "0.8rem", fontWeight: 700, cursor: "pointer", transition: "all 0.2s" }} onClick={() => reject.mutate({ id: s.id })}>
                            رد
                          </button>
                        </div>
                      )}
                    </td>
                  </tr>
                );
              })}
              {swaps.length === 0 && (
                <tr>
                  <td colSpan={4} style={{ padding: "2rem", textAlign: "center", color: "#888" }}>هیچ درخواستی یافت نشد.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </section>
    </div>
  );
}
